import React, { useEffect, useState } from "react";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import { Col, Form, Input } from "antd";

import AboutHeader from "./components/AboutHeader";
import AboutBtn from "./components/AboutButtons";
import "./About.css";
import Editor from "../../../components/TextEditor/textEditor";
import history from "../../../routes/history";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  resetCompanyProfileDetails,
  SearchSuggestions,
  updateCompanyProfileDetails,
} from "../../../redux/actions";
import TopAlert from "../../../components/TopNotification/TopAlert";
import Loader from "../../../components/Loading/Loader";

const About = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );
  const DESC = useSelector(
    (state) =>
      state.getCompanyDetailsReducer.details?.Profiles?.CompanyDescription
  );
  const [message, setMessage] = useState(localStorage.getItem("AboutMessage"));
  const [msgCounter, setMsgCounter] = useState(0);
  const [form] = Form.useForm();
  const [error, setError] = useState(" ");
  const [showAlert, setShowAlert] = useState(false);
  const [saved, setSaved] = useState(false);
  const [loading, setLoading] = useState(true);
  const [redirect , setRedirect] = useState(false)

  const onSave = () => {
    if (msgCounter < 1) {
      setError("This field is required.");
    } else {
      //setError(" ");
      setSaved(true);
      dispatch(updateCompanyProfileDetails({ CompanyDescription: message }));
      setRedirect(true);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, [1000]);
    if (msgCounter > 1) {
      setError(" ");
    }
  }, [msgCounter]);

  useEffect(() => {
    if (success && redirect) {
      setShowAlert(true);
      localStorage.setItem("AboutMessage", message);
      setTimeout(() => {
        setShowAlert(false);
        setSaved(false);
        history.push("/companyprofile")
      }, 4000);
    }
  }, [success,redirect]);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // console.log(msgCounter, "message))))))))))))))))))))))))");

  if (loading) {
    return <Loader />;
  } else {
    return (
      <div className={"main-column"}>
        {showAlert && saved ? (
          <TopAlert
            display={"flex"}
            title={
              location.state.edit
                ? "Description updated Successfully"
                : "Description added Successfully"
            }
            type="success"
          />
        ) : null}
        <Col
          className="about-company-container"
          lg={14}
          md={18}
          sm={24}
          xs={24}
        >
          {windowDimensions.width < 769 ? (
            <ArrowLeftOutlined
              className="crossStyle"
              onClick={() => history.push("/companyprofile")}
            />
          ) : null}
          <div className="about-body">
            <AboutHeader
              aboutcompany={true}
              BidApply="About your company"
              bidspan="Describe your company. Talk about your company’s mission, vision, or values."
            />
            <Form.Item
              className="coverLetter"
              name="coverLetter"
              rules={
                msgCounter < 0
                  ? [
                      {
                        required: true,
                        message: "This field is required.",
                      },
                    ]
                  : ""
              }
            >
              <div className="description_text">Description</div>
              {/* <div style={{paddingBottom: '10px'}}></div> */}
              <Editor
                text={message}
                changeText={(text) => {
                  setMessage(text);
                  if (text === "<p><br></p>") {
                    form.setFieldsValue({ coverLetter: null });
                    setMessage("");
                  } else {
                    form.setFieldsValue({ coverLetter: text });
                  }
                }}
                counter={(val) => {
                  setMsgCounter(val);
                }}
              />
              <span style={{ color: "red" }}> {error}</span>
            </Form.Item>
          </div>
        </Col>
        <div className={"btn-container"}>
          <AboutBtn onSave={onSave} />
        </div>
      </div>
    );
  }
};

export default About;
